import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import { vpsUser } from 'src/user/vpsUser';

function mfRequirePSDTSSTraineeExternalManagement(poTo: RouteLocationNormalized) {
  void poTo;
  const mpsUser = vpsUser();
  const lbIsAuthorized =
    mpsUser.mfIseLCAdmin() ||
    mpsUser.mfIseLCTechSupport() ||
    mpsUser.mfIsePOWERsteerAdminSys() ||
    mpsUser.mfIsePOWERsteerTMO() ||
    mpsUser.mfIsePOWERsteerDTSS();

  return lbIsAuthorized ? true : { name: 'vrteSystemHome' };
}

const vrtPSDTSS: RouteRecordRaw = {
  path: '/powersteer/dtss',
  name: 'vrtPSDTSS',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'ios/operator/trainee/list',
      name: 'vrtPSDTSSTraineeExternalList',
      beforeEnter: mfRequirePSDTSSTraineeExternalManagement,
      component: () => import('./vpgPSDTSSTraineeExternalList.vue'),
    },
    {
      path: 'ios/operator/trainee/operate',
      name: 'vrtPSDTSSTraineeExternalOperate',
      beforeEnter: mfRequirePSDTSSTraineeExternalManagement,
      component: () => import('./vpgPSDTSSTraineeExternalOperate.vue'),
    },
  ],
};

export default vrtPSDTSS;
